import { BreadcrumbItemProps } from './BreadcrumbItem.interfaces';

const BreadcrumbItem = ({ text }: BreadcrumbItemProps) => {
  return <span className="line-inherit mb-0">{text}</span>;
};

export { BreadcrumbItem };
